import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getServiceById } from "../../app/api";
import { useNavigate, useParams } from "react-router-dom";
import ServiceSlider from "./service-slider";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const HTMLTextView = ({ htmlContent }: any) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export enum NewsType {

  image = "Зураг",
  video = "Бичлэг",
  reminder = "Санамж",
  notice = "Зарлал",

}


export interface INews {
  title: string;
  subtitle: string;
  content: string;
  thumb: string;
  images: [string];
  type: NewsType;
  videoUrl: string;
  createAdmin: string;
  updateAdmin: string;
  status: boolean;
}

export default function ServiceDetail() {

  const [news, setNews] = useState<INews>({} as INews);
  const [images, setImages] = useState<any>([]);

  const params = useParams();

  useEffect(() => {
    try {
      getServiceById(params.id).then((res) => {
        setNews(res.data);
        setImages(res.data.images.map((image: any) => {
          return {
            original: image,
            thumbnail: image,
          };
        }));
      });
    } catch(err) {
    }
    window.document.body.scrollTop = 0;
    window.document.documentElement.scrollTop = 0;
  }, [params.id]);
  
  return (
    <>
      <div className="bg-white py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div className="lg:pr-4 mt-4">
              {news.videoUrl ? (
                <iframe
                  src={`https://www.youtube.com/embed/${news.videoUrl.split("v=")[1].split("&")[0]}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Video"
                  className="h-[200px] md:h-[400px] w-full object-cover object-center sm:rounded-lg"
                />
              ) : (
                <img
                  className="h-[200px] md:h-[400px] w-full object-cover"
                  src={news.thumb}
                  alt="image"
                />
              )}

            </div>
            <div>
              <div className="text-base leading-7 text-gray-700 lg:max-w-lg">
                <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-2xl">
                  {news.title}
                </h1>
                <div className="max-w-xl">
                  <HTMLTextView htmlContent={news.content} />
                </div>
               

              </div>
            </div>

            { news.images && news.images.length > 0 &&
            <ImageGallery items={images} />
            }

            

          </div>
        </div>
      </div>

      <div className="bg-white py-24 sm:py-32">
        <ServiceSlider />
      </div>
    </>
  );
}
